import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import styles from "./styles";
import { WhiteLayout } from 'layouts';
import Button from '@mui/material/Button';
import ResetLogo from "assets/images/reset.svg";
import { useDispatch, useSelector } from "react-redux";
import {userPermissionActivationActions} from "../../redux/actions/userPermissionActivation/userPermissionActivationActions"
import queryString from 'query-string';
import {useTranslation} from "react-i18next";
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';

import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

import { Grid } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useFormik } from "formik";

import { ReactComponent as Logo } from "assets/images/corob-logo-red.svg";
import { Spinner } from "reactstrap"
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import LoginIcon from '@mui/icons-material/Login';

const useStyles = makeStyles(styles)

export default function PermissionActivation(props) {
    const classes = useStyles()
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { activationPermissionError, activationPermissionSuccess, activationPermissionLoading } = useSelector((state) => state.userPermissionActivation.activation);
    const {t} = useTranslation('common');
    const [checkBoxError,setCheckboxError] = useState();

    const parsed = queryString.parse(window.location.search);


    const handleLoginClick = () => {
        navigate("/sign-in")
    }

    const formik = useFormik({
        initialValues: {
            database: false,
            analytics: false,
            themes: false,
            graphs: false,
            reject: false,  
      },
        onSubmit : (values, formikHelpers)=> {
        if(values.database === false && values.analytics === false && values.themes === false && values.graphs === false){ 
          setCheckboxError(t('signUp.Permissionrequired'))
        }
        else{
          setCheckboxError()
        dispatch(userPermissionActivationActions(parsed.token, values))
        }
        
        }
    });

    function sendrejectReq() {
        let new_values = {
            database: parsed.database,
            analytics: parsed.analytics,
            themes: parsed.themes,
            graphs: parsed.graphs,
            reject: true, 
        }
        if(new_values.reject === true){
            setCheckboxError()
            dispatch(userPermissionActivationActions(parsed.token, new_values))
        }
      }
    

  return (
    <WhiteLayout>
        <div className={classes.container}>
            <Logo className={classes.logo} />
            <div className={classes.contentdiv}>
                
                {
                    
                    activationPermissionError ?
                    <>
                    <ErrorOutlineSharpIcon  style={{ color: "#C8102E" }} />
                    <div className={classes.errorText}>&nbsp;&nbsp;{activationPermissionError.message}</div>
                    </>
                    :
                    activationPermissionSuccess !== null ? 
                       
                            <>
                             <p>{activationPermissionSuccess}</p>
                            <img src={ResetLogo} alt='success' className={classes.icon} /> 
                            <div className={classes.logoutText}>Permission Granted Successfully!</div>
                            </>
                            :
                            <>
                             <p>{activationPermissionSuccess}</p>
                             <LockOpenOutlinedIcon style={{ color: "#C8102E" }}/>
                            <div className={classes.logoutText}>&nbsp;&nbsp;Assign the following permissions to the active user.</div>
                            </>
                    
                }
                
            </div>
            { activationPermissionError?
            <><Button startIcon={<LoginIcon/>} onClick={handleLoginClick} style={{marginTop: 40}}>Login </Button></>
            :
            activationPermissionSuccess !== null ?
            <><Button startIcon={<LoginIcon/>} onClick={handleLoginClick} style={{marginTop: 40}}>Login </Button></>
            :
            <>
            <form onSubmit={formik.handleSubmit}>
                        <div style={{boxShadow: "3px 3px 3px 3px #9E9E9E", marginTop: 10}}>
                                
                                <div className={classes.contentdiv} >
                                
                                    <Grid className={classes.main} container rowSpacing={1} justifyContent="center" alignItems="center" style={{marginBottom: 10, marginLeft: 30, paddingRight:30}}>
                                    {(parsed.database === 'true') &&
                                    (<Grid item xs={8}>
                                        <FormControlLabel  name="database" value="database" onChange={formik.handleChange} control={<Checkbox style ={{color: "#C8102E"}} />} 
                                        label={t('signUp.databaseFlag')}/>
                                    </Grid>
                                    )
                                    }

                                    {(parsed.analytics === 'true') &&
                                    (<Grid item xs={8}>   
                                        <FormControlLabel  name="analytics" value="analytics" onChange={formik.handleChange} control={<Checkbox style ={{color: "#C8102E"}} />} 
                                        label={t('signUp.analyticsFlag')}/>
                                    </Grid>
                                    )
                                    }

                                    {(parsed.themes === 'true') &&
                                    (
                                    <Grid item xs={8}>
                                        <FormControlLabel  name="themes" value="themes" onChange={formik.handleChange} control={<Checkbox style ={{color: "#C8102E"}} />} 
                                        label={t('signUp.themeFlag')}/>
                                        </Grid>
                                    )
                                    }

                                    {(parsed.graphs === 'true') &&
                                    (<Grid item xs={8}>
                                        <FormControlLabel  name="graphs" value="graphs" onChange={formik.handleChange} control={<Checkbox style ={{color: "#C8102E"}} />} 
                                        label={t('signUp.graphFlag')}/>
                                    </Grid>
                                    )}
                                    
                                    </Grid>
                                
                                    <div>          
                                        <Button  
                                        className='appBtn'
                                        size="meduim"
                                        type="submit"
                                        style={{marginRight: 30, marginBottom: 10}}
                                        >
                                        { activationPermissionLoading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : "Apply" }
                                        </Button>
                                                                                                
                                    </div> 
                                </div>
                        </div> 
                        <div className={classes.container} style={{marginTop: 20}} >
                            <p style={{color: '#c8102e', fontFamily: 'Roboto', fontSize: 15}}>{checkBoxError !== "" ? checkBoxError : ""}</p> 
                        </div>                           
            </form>
            <div>
            <Button startIcon={<DoNotDisturbIcon/>} onClick={sendrejectReq} style={{marginTop: 40, marginRight:30}}>Reject Request </Button>
            <Button startIcon={<LoginIcon/>} onClick={handleLoginClick} style={{marginTop: 40}}>Login </Button>
            </div>
            </>
            }
            {/* <Button onClick={handleLoginClick} style={{marginTop: 40}}>Login </Button> */}
            </div>
    </WhiteLayout>
  )
}
